"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaStyle = exports.MediaScreenSize = void 0;
var styled_components_1 = require("styled-components");
var MediaScreenSize;
(function (MediaScreenSize) {
    MediaScreenSize["DESKTOP"] = "desktop";
    MediaScreenSize["TABLET"] = "tablet";
    MediaScreenSize["MOBILE"] = "mobile";
})(MediaScreenSize || (exports.MediaScreenSize = MediaScreenSize = {}));
function mediaStyle(screenSize) {
    if (screenSize === void 0) { screenSize = MediaScreenSize.MOBILE; }
    return function customCss(strings) {
        var values = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            values[_i - 1] = arguments[_i];
        }
        var mediaString = 'max-width: 601px';
        if (screenSize === MediaScreenSize.DESKTOP) {
            mediaString = 'min-width: 961px';
        }
        else if (screenSize === MediaScreenSize.TABLET) {
            mediaString = 'max-width: 960px';
        }
        return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      @media (", ") {\n        ", "\n      }\n    "], ["\n      @media (", ") {\n        ", "\n      }\n    "])), mediaString, styled_components_1.css.apply(void 0, __spreadArray([strings], values, false)));
    };
}
exports.mediaStyle = mediaStyle;
var templateObject_1;
